import * as React from 'react'

import styled from '@theme/styled-components'
import { inProgressMarker, stoppedMarker, endedMarker } from '@components/marker/business'
import useI18n from '@store/i18n/useI18n'

interface Props {
  chantier: BusinessResume
  onClick: () => void
  height?: number
}

const Chantier = ({ chantier, onClick, height = 100 }: Props) => {
  const i18n = useI18n()
  return (
    <Container onClick={onClick} height={height} hasNewDeclarations={chantier.hasNewDeclarations}>
      <Information>
        <Title>{chantier.title}</Title>
        <Subtitle>{chantier.address}</Subtitle>
        <Libelle>{chantier.subtitle}</Libelle>
        {chantier.failedGeoloc && (
          <FailedGeolocLabel>{i18n.t('components.businessList.geolocFailed')}</FailedGeolocLabel>
        )}
      </Information>
      <Icon>
        {chantier.state === 'inprogress'
          ? inProgressMarker(30, chantier.source)
          : chantier.state === 'stopped'
          ? stoppedMarker(30, chantier.source)
          : endedMarker(30, chantier.source)}
      </Icon>
    </Container>
  )
}

export default Chantier

const Container = styled('div')<{ height: number; hasNewDeclarations?: boolean }>`
  cursor: pointer;
  margin: 0;
  display: flex;
  height: ${(props) => props.height - 1}px;
  padding: 0 15px;

  flex-direction: row;
  align-items: center;
  &:hover {
    background-color: ${(props) => props.theme.colors.chantierHoverBackground};
  }

  border-bottom-width: 1px;
  border-bottom-color: ${(props) => props.theme.colors.chantierBorder};
  border-bottom-style: solid;

  ${(props) =>
    props.hasNewDeclarations &&
    `
  border-right-width: 5px;
  border-right-color: red;
  border-right-style: solid;
  `}
`
const Information = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 5px;
`
const Title = styled('div')`
  ${(props) => props.theme.fonts.chantierTitle};
  margin: 3px 0;
`
const Subtitle = styled('div')`
  ${(props) => props.theme.fonts.chantierSubTitle};
  margin: 3px 0;
`
const Libelle = styled('div')`
  ${(props) => props.theme.fonts.chantierLibelle};
  margin: 3px 0;
`
const Icon = styled('div')`
  justify-content: center;
  align-items: center;
  display: flex;
`
const FailedGeolocLabel = styled('div')`
  ${(props) => props.theme.fonts.failedGeolocLibelle};
`
